/**
 *  Nike-style hover zoom
 *  Desktop-only. Side panel body par fixed hai, isliye overflow:hidden se clip nahi hota.
 */
(function () {
  var ZOOM = 2.5;
  var PANEL_MAX = 560;
  var PANEL_MIN = 300;
  var GAP = 16;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var wideEnough = window.innerWidth >= 1070;
  if (!canHover || !wideEnough) return;

  var panel = null;
  var lens = null;
  var activeEl = null;
  var rect = null;
  var side = 'right';

  function build() {
    panel = document.createElement('div');
    panel.className = 'hz-panel';
    panel.style.cssText = [
      'position:fixed',
      'z-index:60',
      'background-repeat:no-repeat',
      'background-color:#f5f5f5',
      'border:1px solid rgba(0,0,0,.08)',
      'pointer-events:none',
      'opacity:0',
      'transition:opacity .12s ease'
    ].join(';');
    document.body.appendChild(panel);

    lens = document.createElement('div');
    lens.className = 'hz-lens';
    lens.style.cssText = [
      'position:fixed',
      'z-index:59',
      'background:rgba(255,255,255,.28)',
      'border:1px solid rgba(0,0,0,.35)',
      'pointer-events:none',
      'opacity:0',
      'transition:opacity .12s ease'
    ].join(';');
    document.body.appendChild(lens);
  }

  function panelBox(r) {
    var spaceRight = window.innerWidth - r.right - GAP * 2;
    var spaceLeft = r.left - GAP * 2;

    side = spaceRight >= PANEL_MIN || spaceRight >= spaceLeft ? 'right' : 'left';
    var space = side === 'right' ? spaceRight : spaceLeft;
    if (space < PANEL_MIN) return null;

    var w = Math.min(PANEL_MAX, space);
    var h = Math.min(w * (r.height / r.width), window.innerHeight - GAP * 2);
    var top = Math.max(GAP, Math.min(r.top, window.innerHeight - h - GAP));
    var left = side === 'right' ? r.right + GAP : r.left - w - GAP;

    return { w: w, h: h, top: top, left: left };
  }

  function show(el) {
    var src = el.dataset.zoomSrc;
    if (!src) return;

    rect = el.getBoundingClientRect();
    if (rect.width < 200) return;

    var box = panelBox(rect);
    if (!box) return;

    if (!panel) build();

    activeEl = el;

    panel.style.width = box.w + 'px';
    panel.style.height = box.h + 'px';
    panel.style.top = box.top + 'px';
    panel.style.left = box.left + 'px';
    panel.style.backgroundImage = 'url("' + src + '")';
    panel.style.backgroundSize = rect.width * ZOOM + 'px ' + rect.height * ZOOM + 'px';
    panel.style.opacity = '1';

    var lw = box.w / ZOOM;
    var lh = box.h / ZOOM;
    lens.style.width = Math.min(lw, rect.width) + 'px';
    lens.style.height = Math.min(lh, rect.height) + 'px';
    lens.style.opacity = '1';

    el.style.cursor = 'crosshair';
  }

  function move(e) {
    if (!activeEl || !panel || panel.style.opacity !== '1') return;

    rect = activeEl.getBoundingClientRect();

    var lw = parseFloat(lens.style.width);
    var lh = parseFloat(lens.style.height);

    var lx = e.clientX - lw / 2;
    var ly = e.clientY - lh / 2;
    lx = Math.max(rect.left, Math.min(lx, rect.right - lw));
    ly = Math.max(rect.top, Math.min(ly, rect.bottom - lh));
    lens.style.left = lx + 'px';
    lens.style.top = ly + 'px';

    var px = (lx - rect.left) * ZOOM;
    var py = (ly - rect.top) * ZOOM;
    panel.style.backgroundPosition = '-' + px + 'px -' + py + 'px';
  }

  function hide() {
    if (activeEl) activeEl.style.cursor = '';
    activeEl = null;
    if (panel) panel.style.opacity = '0';
    if (lens) lens.style.opacity = '0';
  }

  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest('[data-hover-zoom]');
    if (!el || el === activeEl) return;
    if (e.target.closest('.product-single__media-zoom')) return;
    show(el);
  });

  document.addEventListener('mousemove', move, { passive: true });

  document.addEventListener('mouseout', function (e) {
    if (!activeEl) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('[data-hover-zoom]') === activeEl) return;
    hide();
  });

  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
  document.addEventListener('click', hide);
})();